const getDefaultAlignment = _ref => {
  let {
    currentIndex,
    minIndex,
    maxIndex,
    hasSlideOverflow
  } = _ref;
  if (!hasSlideOverflow) {
    // There aren't enough slides
    return 'center';
  }
  if (currentIndex === maxIndex) {
    return 'right';
  }
  if (currentIndex === minIndex) {
    return 'left';
  }
  return 'center';
};
export default getDefaultAlignment;